import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
// import { selectCity } from "../../redux/actions/citiesAction";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { customStyles } from "../../selectStyles";
import { useNavigate } from "react-router-dom";

FormContent.propTypes = {};

function FormContent(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchjobName, setSearchjobName] = useState("");
  const [cityId, setcityId] = useState("");
  console.log("searchjobName", searchjobName);

  const [loading, setLoading] = useState(true);

  const { cityList, selectedcityId } = useSelector(
    (state) => state.cities);

  const handleCitySelect = (selectedOption) => {
    console.log("selectedOption", selectedOption);

    if (selectedOption === null) {
      setcityId(null);
    } else {
      setcityId(selectedOption.value);
    }
  }; 
  useEffect(() => {
    dispatch(fetchCityData()).finally(() => setLoading(false));
  }, [dispatch]);

  if (loading) {
    return <div>Loading cities...</div>;
  }
   
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchjobName && !cityId) {
      alert("Please select a city or enter a job title.");
      return;
    }
    const queryParams = new URLSearchParams();
    if (searchjobName) queryParams.set("search", searchjobName);
    if (cityId) queryParams.set("cityId", cityId);
    navigate(`/SearchJobs?${queryParams.toString()}`);
  };

  return (
    <div className="content formContent">
      <div className="pb-3">
        <h2 className=" text-center pb-3">Find the job that fits your life</h2>
        <p className=" text-center">
          Resume-Library is a true performance-based job board. Enjoy custom
          hiring products and access to up to 10,000 new resume registrations
          daily, with no subscriptions or user licences.
        </p>
      </div>
      <div className="form-sl">
        <form onSubmit={handleSubmit}>
          <div className="row-group-search home1">
            <div className="form-group-2">
              {/* <span className="icon-map-pin me-3"></span> */}
              <ReactSelect
                options={cityList}
                onChange={handleCitySelect}
                value={
                  cityList.find((option) => option.value === cityId) || null
                }
                placeholder="Select city"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control banner-city"
                isClearable
              />
            </div>
            <div className="form-group-1">
              <input
                type="text"
                className="input-filter-search"
                placeholder="Job title, key words or company"
                value={searchjobName}
                onChange={(e) => setSearchjobName(e.target.value)}
              />
            </div>

            <div className="form-group-4 ms-2">
              <button
                type="submit"
                className="btn khojPrimaryBtn"
                style={{ width: "137px", height: "50px" }}
              >
                Find Jobs
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FormContent;
